import { render, staticRenderFns } from "./ManageFrequentlyAskQuestions.vue?vue&type=template&id=913210bc&scoped=true"
import script from "./ManageFrequentlyAskQuestions.vue?vue&type=script&lang=js"
export * from "./ManageFrequentlyAskQuestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "913210bc",
  null
  
)

export default component.exports